var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _rect2, _path10, _rect3, _path11, _rect4, _path12, _rect5, _path13, _rect6, _path14, _rect7, _path15, _rect8, _path16, _rect9, _path17, _rect10, _path18, _rect11, _path19, _rect12, _rect13, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroHomeLg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 531,
    viewBox: "0 0 1440 531",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 697.5,
    cy: 220.5,
    r: 127.5,
    fill: "#D2B487"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 221.084C0 221.084 105.983 168.369 265.5 186.586C394 201.261 390.579 214.108 550 221.084C676.859 226.635 1074 182 1191.5 182C1309 182 1440 221.084 1440 221.084V531H0V221.084Z",
    fill: "#F2EBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 307.904C0 307.904 230.614 282.213 395 282.405C556.458 282.595 608 333.985 782 307.904C893.125 291.248 1134 276.265 1208 282.405C1282 288.546 1440 307.904 1440 307.904V531H0V307.904Z",
    fill: "#E4D7C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1050.5 289.795C1068.01 289.795 1068.5 289.795 1102 289.795C916.5 300.145 855.5 515 855.5 515H697C697 515 884 289.795 1050.5 289.795Z",
    fill: "#F2EBDB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.55 247.736C1218.55 246.301 1217.53 245.068 1216.12 244.792L1129.71 227.85C1129.41 227.791 1129.13 227.688 1128.86 227.544L1075.3 198.548C1074.01 197.851 1072.41 198.185 1071.51 199.34L1040.14 239.524C1039.72 240.052 1039.5 240.702 1039.5 241.371V287.474C1039.5 289.131 1040.84 290.474 1042.5 290.474H1215.55C1217.2 290.474 1218.55 289.131 1218.55 287.474V247.736Z",
    fill: "#C08A8A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.88 247.901C1218.88 246.454 1217.85 245.213 1216.42 244.951L1130.04 229.059C1128.2 228.72 1126.5 230.135 1126.5 232.01V287.61C1126.5 289.267 1127.84 290.61 1129.5 290.61H1215.88C1217.54 290.61 1218.88 289.267 1218.88 287.61V247.901Z",
    fill: "#B57878"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1168 219.568C1167.93 219.536 1167.86 219.512 1167.79 219.495L1075.96 198.69C1074.82 198.432 1074.24 200.008 1075.27 200.551L1129.79 229.127C1129.88 229.173 1129.97 229.206 1130.07 229.224L1218 245.573C1219.15 245.787 1219.67 244.19 1218.62 243.687L1168 219.568Z",
    fill: "#E4D7C7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 424.289C1440 424.289 1178 383.07 1045 408.458C897.883 436.542 859.023 413.561 679.5 416.596C495.5 419.707 367.5 394 249.5 394C131.5 394 0 424.289 0 424.289V531H1440V424.289Z",
    fill: "#E2DCD8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M213 136.215H229.216L226.189 81.0804H216.027L213 136.215Z",
    fill: "#6D6363"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.24321,
    height: 29.1889,
    transform: "matrix(1 0 0 -1 219.595 92.7559)",
    fill: "#6D6363"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M229.215 0H212.999L216.026 55.1346H226.188L229.215 0Z",
    fill: "#6D6363"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.24321,
    height: 29.1889,
    transform: "matrix(-1 0 0 1 222.729 42.1618)",
    fill: "#6D6363"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M153 76.2155V59.9994L208.135 63.0264V73.1885L153 76.2155Z",
    fill: "#6D6363"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 196.459,
    y: 69.621,
    width: 3.24321,
    height: 29.1889,
    transform: "rotate(-90 196.459 69.621)",
    fill: "#6D6363"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M289.215 59.9994V76.2155L234.08 73.1885V63.0264L289.215 59.9994Z",
    fill: "#6D6363"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 247.054,
    y: 66.4859,
    width: 3.24321,
    height: 29.1889,
    transform: "rotate(90 247.054 66.4859)",
    fill: "#6D6363"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M276.036 109.183L284.144 95.1398L234.883 70.1939L229.802 78.9945L276.036 109.183Z",
    fill: "#6D6363"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 3.24321,
    height: 29.1889,
    transform: "matrix(0.5 -0.866025 -0.866025 -0.5 241.696 81.7429)",
    fill: "#6D6363"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M166.178 27.0322L158.07 41.0757L207.331 66.0216L212.412 57.2209L166.178 27.0322Z",
    fill: "#6D6363"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 3.24321,
    height: 29.1889,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 199.448 53.7305)",
    fill: "#6D6363"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M166.178 109.183L158.07 95.1398L207.332 70.1939L212.413 78.9945L166.178 109.183Z",
    fill: "#6D6363"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 200.518,
    y: 81.7429,
    width: 3.24321,
    height: 29.1889,
    transform: "rotate(-120 200.518 81.7429)",
    fill: "#6D6363"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M276.037 27.0322L284.145 41.0757L234.883 66.0216L229.802 57.2209L276.037 27.0322Z",
    fill: "#6D6363"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 242.766,
    y: 53.7305,
    width: 3.24321,
    height: 29.1889,
    transform: "rotate(60 242.766 53.7305)",
    fill: "#6D6363"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M248.139 131.145L262.183 123.037L231.994 76.8021L223.193 81.8831L248.139 131.145Z",
    fill: "#6D6363"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 3.24321,
    height: 29.1889,
    transform: "matrix(0.866025 -0.5 -0.5 -0.866025 232.121 90.2108)",
    fill: "#6D6363"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M194.075 5.07068L180.031 13.1787L210.22 59.4132L219.021 54.3322L194.075 5.07068Z",
    fill: "#6D6363"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 3.24321,
    height: 29.1889,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 209.538 44.8272)",
    fill: "#6D6363"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M194.075 131.145L180.032 123.037L210.22 76.8021L219.021 81.8831L194.075 131.145Z",
    fill: "#6D6363"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 210.094,
    y: 90.2108,
    width: 3.24321,
    height: 29.1889,
    transform: "rotate(-150 210.094 90.2108)",
    fill: "#6D6363"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M248.14 5.07068L262.183 13.1787L231.994 59.4132L223.194 54.3322L248.14 5.07068Z",
    fill: "#6D6363"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 232.676,
    y: 44.8272,
    width: 3.24321,
    height: 29.1889,
    transform: "rotate(30 232.676 44.8272)",
    fill: "#6D6363"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 219.772,
    y: 66.772,
    width: 96.1518,
    height: 2.67088,
    fill: "#6D6363"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M310.583 53.4176L364 48.0758L354.652 64.1011L364 81.4619L310.583 77.4555V53.4176Z",
    fill: "#6D6363"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M221.107 244.386V205.658M221.107 205.658L171.383 242.632C170.617 243.202 169.564 242.477 169.824 241.558L186.386 182.956M221.107 205.658L255.829 182.956M221.107 205.658V158.918M221.107 205.658L186.386 182.956M186.386 182.956L273.429 242.717C274.217 243.258 275.242 242.491 274.946 241.583L255.829 182.956M186.386 182.956L199.74 140.222M186.386 182.956L221.107 158.918M186.386 182.956H255.829M255.829 182.956L221.107 158.918M255.829 182.956L242.474 140.222M199.74 140.222L221.107 158.918M199.74 140.222L208.675 109.506M199.74 140.222L233.539 109.506M221.107 158.918L242.474 140.222M221.107 158.918V66.7722M242.474 140.222L208.675 109.506M242.474 140.222L233.539 109.506M221.107 66.7722L208.675 109.506M221.107 66.7722L233.539 109.506",
    stroke: "#6D6363"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroHomeLg);
export default __webpack_public_path__ + "static/media/hero-home-lg.e1c1838c.svg";
export { ForwardRef as ReactComponent };